export function scrollToHash(hash) {
  return (e) => {
    e.preventDefault();
    if (window.__lenis) {
      window.__lenis.scrollTo(hash, { offset: -72, duration: 1.4 });
    } else {
      document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
    }
  };
}
